<template>
  <div id="app">
    <!-- 路由占位符 -->
    <router-view v-if="isRouterAlive"></router-view>
  </div>
</template>

<script>
/* eslint-disabled mapState,*/
import { mapMutations } from "vuex";
//eslint-disabled-next-line
//import { exportFile } from "@/js/docx.js";
export default {
  name: "app",
  created() {
    // exportFile("../src/assets/fonts/ARIALUNI.TTF","Arial Unicode MS.TTF");
    // exportFile("../src/assets/pic/0001.jpg","0001.jpg");
    localStorage.setItem("pixel", window.screen.height * window.screen.width);
    let availWh = {
      availWidth: window.screen.availWidth,
      availHeight: window.screen.availHeight
    };
    this.SETAVAILWH(availWh);
  },
  mounted() {
    var that = this;
    // 节流 ms 触发间隔毫秒
    var ms = 100;
    var lastClick = Date.now() - ms;
    // 初始化
    this.init();
    window.addEventListener("resize", () => {
      // 节流
      if (Date.now() - lastClick >= ms) {
        that.init();
        lastClick = Date.now();
      }
    });
  },
  data() {
    return {
      isRouterAlive: true,
      showdialog: false
    };
  },
  provide() {
    return {
      reload: this.reload
    };
  },
  methods: {
    ...mapMutations("resolution", ["SETINNERWH", "SETAVAILWH"]),
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true;
      });
    },
    init() {
      let innerWH = {
        innerWidth: window.innerWidth,
        innerHeight: window.innerHeight
      };

      this.SETINNERWH(innerWH);

      /* console.log("最大宽", window.screen.availWidth);
      console.log("最大高", window.screen.availHeight);

      console.log(" window.innerWidth", window.innerWidth);
      console.log(" window.innerHeight", window.innerHeight); */
    }
    /*  mask(){
      this.maskShow=!this.maskShow;
    } */
  }
};
</script>

<style>
#app {
  background-color: #fff;
}

.mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 99;
}
</style>
